<div class="feed-type-selector">
  <div class="space"></div>

  @if (availableFeedTypesQuery.isLoading()) {
    <app-loading></app-loading>
  } @else if (availableFeedTypesQuery.isError()) {
    <div class="error-state">
      {{ "feed-type-selector.error.failed-to-load-feed-types" | translate }}
    </div>
  } @else {
    <div class="feed-types">
      @for (feedType of feedTypes(); track feedType) {
        <div
          class="feed-type"
          (click)="selectFeedTypeId(feedType.id)"
          [class.disabled]="feedType.left === 0"
          [ngClass]="{ selected: selectedFeedTypeId == feedType.id }"
        >
          <div class="feed-type-header">
            <h4>{{ feedType.name }}</h4>
            <p>{{ feedType.description }}</p>
          </div>
          <div class="feed-type-left-count">
            <p>{{ "feed-type-selector.label.left" | translate }}:</p>
            <p class="left-count">{{ feedType.left }}</p>
          </div>
          <div class="feed-type-content">
            <img
              [src]="feedType.image"
              alt="{{ feedType.name }}"
              class="feed-type-image"
            />
          </div>
        </div>
      }
    </div>
  }
</div>
